import React, { useState, useEffect } from "react";
import { Badge, OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import Switch from "react-switch";
import { connect,useSelector } from "react-redux";
import { activeBot } from "../../actions/bot-action";
import NoData from "../common/NoData";
import "./BotTab.scss";
import { decimalOf, isLong } from "../../utils/Utils";
import { toast } from "react-toastify";
import CreateBotFromRentModal from "../marketplace/bots/CreateBotFromRentModal";
import { t } from "i18next";

const BotTab = (props) => {
  const { bots, onShowBotDetail,startItem,itemsPerPage,pageNum,selectedTab,selectedExchangeId ,onShowBotEdit,t,sort,orderBy} = props;
  const theme =  useSelector((state) => state.settings.selected_theme) || 'light';
  const [statusList, setStatusList] = useState();
  //const [startItem, setStartItem] = useState(0);

  useEffect(() => {
    setStatusList(
      bots.reduce((acc, item) => {
        acc[item.id] = item.status === "active";
        return acc;
      }, {})
    );
    //setStartItem(0);
  }, [bots]);
  // const clickEditRentBot = (bot)=>{
  //   setBotSelected(updateEditRentBotConfig(bot))
  //   setShowEditRentBotModal(true)
  // }

  const rows = bots
    //.slice(startItem, startItem + itemsPerPage)
    .map((bot, index) => {
      const pair = bot.exchange_pair.pair;
      const strategy = bot.strategy;
      const baseCoin = strategy.toLowerCase() == "long" ? pair.to : pair.from;

      const statusVariant =
        bot.deal_status === 1
          ? "success"
          : bot.deal_status === 2
          ? "secondary"
          : "danger";
      const showDetail = () => {
        onShowBotDetail(bot.id);
      };
      const showEdit = () => {
        onShowBotEdit(bot.id);
      };
      return (
        <tr key={bot.id} className={`theme-border ${theme}`}>
          <td>{startItem + index }</td>
          <td className="text-left">
            <img src={`/images/icons/bots/${bot.type?bot.type:'rent'}.png`} className="bot-icon-list"></img>
            {bot.name}{bot.notice != "" &&  <OverlayTrigger
      placement="top"
      overlay={<Tooltip>{bot.notice}</Tooltip>}
    ><i className="fa fa-exclamation-circle deativate-warning" aria-hidden="true"></i></OverlayTrigger> }
          </td>
          <td>
            <span className="mr-1">
              {pair.from}/{pair.to}
            </span>
            <span className={isLong(bot.strategy) ? "long" : "short"}>
              {bot.strategy}
            </span>
          </td>
          <td>
            {parseFloat(bot.deals_analysis.total_performance).toFixed(
              decimalOf(baseCoin)
            ) || "0"}{" "}
            {baseCoin}
          </td>
          <td>{parseFloat(bot.deals_analysis.return_value_avg).toFixed(2) || "0"}%</td>
          <td>
            <Badge variant={statusVariant} className="w-75 p-1">
              {bot.deal_status_name}
            </Badge>
          </td>
          <td>
            <Switch
              checkedIcon={false}
              uncheckedIcon={false}
              checked={(statusList && statusList[bot.id]) || false}
              onChange={(checked) => {
                const list = {
                  ...statusList,
                };
                list[bot.id] = checked;
                setStatusList(list);
                props
                  .activeBot(bot.id, checked ? "active" : "inactive",selectedExchangeId,itemsPerPage,pageNum,selectedTab,orderBy,sort)
                  .then(() => {})
                  .catch((err) => {
                    toast.error(err);
                    const list = {
                      ...statusList,
                    };
                    list[bot.id] = !checked;
                    setStatusList(list);
                  });
              }}
              height={20}
              width={40}
              onColor="#05CD99"
            />
            <a href={!bot.rent_id?`/bots?copy=${bot.id}`:void(null)} className="" >
              <i
                className={`far fa-copy action-icon ${bot.rent_id?'disabled':''}`}
              ></i>
            </a>
            {!bot.rent_id?( <a href="#" onClick={showEdit} className="ml-3">
              <i
                className="far fa-edit action-icon"
              ></i>
            </a>):( <a href="#" onClick={showEdit} className="ml-3">
              <i
                className="far fa-edit action-icon"
              ></i>
            </a>)}
           
            <a href="#" onClick={showDetail} className="ml-3">
            <i className="far fa-eye action-icon"></i>
            </a>
          </td>
         
        </tr>
      );
    });
  return (
    <div className="mt-4 bot-tab">
      <Table responsive className={`theme-bg ${theme}`}>
        <thead>
          <tr>
            <th>#</th>
            <th className="text-left">{t("bn")}</th>
            <th>{t("pair")}</th>
            <th>{t("return")}</th>
            <th className="joy-performance">{t("performance")}</th>
            <th>{t("status")}</th>
            <th>{t("action")}</th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </Table>
      
      <NoData count={bots && bots.length} />
      {/* <div className="bottom-center">
        <CustomPagination
          itemsCountPerPage={itemsPerPage}
          startItem={startItem}
          totalCount={bots.length}
          onChange={setStartItem}
        />
      </div> */}
    </div>
  );
};

export default connect(null, { activeBot })(BotTab);
